var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerWithCompliant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007338"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 170",
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DBBEFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007347"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39905",
    x: 9.5,
    y: 23.2314,
    width: 8.21292,
    height: 8.26888,
    stroke: "#B246FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39906",
    x: 22.2871,
    y: 23.2314,
    width: 8.21292,
    height: 8.26888,
    stroke: "#B246FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39907",
    x: 22.2871,
    y: 10.5,
    width: 8.21292,
    height: 8.26888,
    stroke: "#B246FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39908",
    x: 9.5,
    y: 10.5,
    width: 8.21292,
    height: 8.26888,
    stroke: "#B246FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerWithCompliant);
export default __webpack_public_path__ + "static/media/partner-with-compliant.60da1f43061c74ca4e36ca3d2f1a734c.svg";
export { ForwardRef as ReactComponent };